import React from 'react';

import { Button, Dialog, DialogContent, Grid, TextField } from '@mui/material';

import { COLORS } from '../../../Constant/COLORS';

import { TypoPoppBlue, TypoPoppins } from '../../../Components/Typo';

const AskAdvance = props => (
  <Dialog
    PaperProps={{
      style: { borderRadius: '38px', padding: '24px', maxWidth: '400px' },
    }}
    {...props}
  >
    <DialogContent>
      <TypoPoppBlue variant='h6' textAlign='center' fontWeight={600} mb={3}>
        Account Details
      </TypoPoppBlue>
      <Grid container columns={3} rowSpacing={3} width='fit-content' mb={3}>
        <Grid item component={TypoPoppins} color={COLORS.black} lg={1}>
          Bank Details :
        </Grid>
        <Grid item lg={2}>
          <TypoPoppins color={COLORS.black}>Mohammed Husamtha</TypoPoppins>
          <TypoPoppins color={COLORS.black}>HNB Mawanella</TypoPoppins>
          <TypoPoppins color={COLORS.black}>084556564654</TypoPoppins>
        </Grid>
        <Grid item component={TypoPoppins} color={COLORS.black} display='inline' lg={1} alignSelf='center'>
          Advance :
        </Grid>
        <Grid item lg={2}>
          <TextField
            InputProps={{ sx: { backgroundColor: COLORS.grey12 } }}
            sx={{ '.MuiOutlinedInput-notchedOutline': { all: 'unset' } }}
          />
        </Grid>
      </Grid>
      <TypoPoppins color={COLORS.black} variant='caption' ml={2} component='p'>
        Note : If you get the Advance from Client you can&rsquo;t Reject.and your phone number send is send to Client
      </TypoPoppins>
      <Button sx={{ px: 6, display: 'table', mx: 'auto', mt: 3 }} color='blue' fullWidth={false} size='medium'>
        Send
      </Button>
    </DialogContent>
  </Dialog>
);

export default AskAdvance;
